import React from 'react'
import { connect } from 'react-redux'
//import { Button, TextField, MenuItem, FormGroup, Grid, Radio, FormControl, RadioGroup, FormControlLabel, FormLabel } from '@material-ui/core'
//import VSelect from 'Components/Select/VSelect'
import Grid from '@material-ui/core/Grid'
import Configuration from './Configuration'
import AccountingView from './AccountingView'
import Paper from '@material-ui/core/Paper'
const CustomAccounting = ({config}) => {

  return (
    <Grid container spacing={2}>
      <Grid item md={3}>
        <Paper style={{padding: '1rem', backgroundColor: 'white'}}>
          <Configuration />
        </Paper>
      </Grid>
      <Grid item md={9} >
        {(config.accountingRecipientType.length>0 && config.recipientType.length>0) &&<AccountingView />}
      </Grid>
    </Grid>
  )
}

export default connect(state=>({
  config: state.customerAccounting.config
}))
(CustomAccounting)

